var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "edit-dialog",
          attrs: {
            title: _vm.ruleForm.id === "" ? "新增内容" : "编辑内容",
            visible: _vm.dialogVisible,
            width: "900px",
            top: "100px",
            "modal-append-to-body": true,
            "append-to-body": "",
            "close-on-click-modal": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            closed: _vm.hide,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "150px",
              },
            },
            [
              _c(
                "div",
                { staticClass: "form_bj_box" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "策略名称", prop: "strategyName" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "99" },
                        model: {
                          value: _vm.ruleForm.strategyName,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "strategyName", $$v)
                          },
                          expression: "ruleForm.strategyName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "收端渠道", prop: "channelFlag" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: {
                            change: () => {
                              _vm.ruleForm.receiverChannelNameList = ""
                            },
                          },
                          model: {
                            value: _vm.ruleForm.channelFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "channelFlag", $$v)
                            },
                            expression: "ruleForm.channelFlag",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "0" } }, [
                            _vm._v("全部渠道"),
                          ]),
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("指定渠道"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.ruleForm.channelFlag == "1"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea" },
                            on: { focus: _vm.handleClick },
                            model: {
                              value: _vm.ruleForm.receiverChannelNameList,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.ruleForm,
                                  "receiverChannelNameList",
                                  $$v
                                )
                              },
                              expression: "ruleForm.receiverChannelNameList",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "uid", prop: "receiverUidSet" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.ruleForm.receiverUidSet,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "receiverUidSet", $$v)
                          },
                          expression: "ruleForm.receiverUidSet",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "uuid", prop: "receiverUuidSet" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.ruleForm.receiverUuidSet,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "receiverUuidSet", $$v)
                          },
                          expression: "ruleForm.receiverUuidSet",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "应用版本", prop: "apkVersionMax" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-around",
                            "text-align": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.ruleForm.apkVersionMax,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "apkVersionMax", $$v)
                                  },
                                  expression: "ruleForm.apkVersionMax",
                                },
                              }),
                              _c("div", [_vm._v("最大版本")]),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.ruleForm.apkVersionMin,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "apkVersionMin", $$v)
                                  },
                                  expression: "ruleForm.apkVersionMin",
                                },
                              }),
                              _c("div", [_vm._v("最小版本")]),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "SDK版本", prop: "sdkVersionMax" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-around",
                            "text-align": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.ruleForm.sdkVersionMax,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "sdkVersionMax", $$v)
                                  },
                                  expression: "ruleForm.sdkVersionMax",
                                },
                              }),
                              _c("div", [_vm._v("最大版本")]),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.ruleForm.sdkVersionMin,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "sdkVersionMin", $$v)
                                  },
                                  expression: "ruleForm.sdkVersionMin",
                                },
                              }),
                              _c("div", [_vm._v("最小版本")]),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._l(_vm.ruleForm.strategyDetails, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "form_bj_box" },
                  [
                    _c("div", { staticClass: "form_bj_box_title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.workPatternName[+item.workPattern] ||
                            _vm.workPatternName[index + 1]
                        ) + "\n        "
                      ),
                    ]),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "白名单",
                          prop:
                            "strategyDetails." + index + ".writeListStrategy",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: item.writeListStrategy,
                              callback: function ($$v) {
                                _vm.$set(item, "writeListStrategy", $$v)
                              },
                              expression: "item.writeListStrategy",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v("直接播放"),
                            ]),
                            _c("el-radio", { attrs: { label: "2" } }, [
                              _vm._v("选择确认"),
                            ]),
                            _c("el-radio", { attrs: { label: "3" } }, [
                              _vm._v("停止播放"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "灰名单",
                          prop:
                            "strategyDetails." + index + ".grayListStrategy",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: item.grayListStrategy,
                              callback: function ($$v) {
                                _vm.$set(item, "grayListStrategy", $$v)
                              },
                              expression: "item.grayListStrategy",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v("直接播放"),
                            ]),
                            _c("el-radio", { attrs: { label: "2" } }, [
                              _vm._v("选择确认"),
                            ]),
                            _c("el-radio", { attrs: { label: "3" } }, [
                              _vm._v("停止播放"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "黑名单",
                          prop:
                            "strategyDetails." + index + ".blackListStrategy",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: item.blackListStrategy,
                              callback: function ($$v) {
                                _vm.$set(item, "blackListStrategy", $$v)
                              },
                              expression: "item.blackListStrategy",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v("直接播放"),
                            ]),
                            _c("el-radio", { attrs: { label: "2" } }, [
                              _vm._v("选择确认"),
                            ]),
                            _c("el-radio", { attrs: { label: "3" } }, [
                              _vm._v("停止播放"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "其他名单",
                          prop:
                            "strategyDetails." + index + ".otherListStrategy",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: item.otherListStrategy,
                              callback: function ($$v) {
                                _vm.$set(item, "otherListStrategy", $$v)
                              },
                              expression: "item.otherListStrategy",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v("直接播放"),
                            ]),
                            _c("el-radio", { attrs: { label: "2" } }, [
                              _vm._v("选择确认"),
                            ]),
                            _c("el-radio", { attrs: { label: "3" } }, [
                              _vm._v("停止播放"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "“选择确认”提示模板",
                          prop:
                            "strategyDetails." +
                            index +
                            ".selectConfirmHitTemp",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: item.selectConfirmHitTemp,
                              callback: function ($$v) {
                                _vm.$set(item, "selectConfirmHitTemp", $$v)
                              },
                              expression: "item.selectConfirmHitTemp",
                            },
                          },
                          _vm._l(_vm.templateList, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.templateName,
                                value: item.templateCode,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "“停止播放”提示模板",
                          prop: "strategyDetails." + index + ".stopPlayHitTemp",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: item.stopPlayHitTemp,
                              callback: function ($$v) {
                                _vm.$set(item, "stopPlayHitTemp", $$v)
                              },
                              expression: "item.stopPlayHitTemp",
                            },
                          },
                          _vm._l(_vm.templateList, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.templateName,
                                value: item.templateCode,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "div",
                { staticClass: "form_bj_box" },
                [
                  _c("div", { staticClass: "form_bj_box_title" }, [
                    _vm._v("播放提示"),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: "播放提示", prop: "toastFlag" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.toastFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "toastFlag", $$v)
                            },
                            expression: "ruleForm.toastFlag",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("开启"),
                          ]),
                          _c("el-radio", { attrs: { label: "0" } }, [
                            _vm._v("关闭"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "白名单提示", prop: "whiteToast" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.ruleForm.whiteToast,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "whiteToast", $$v)
                          },
                          expression: "ruleForm.whiteToast",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "灰名单提示", prop: "grayToast" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.ruleForm.grayToast,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "grayToast", $$v)
                          },
                          expression: "ruleForm.grayToast",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "黑名单提示", prop: "blackToast" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.ruleForm.blackToast,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "blackToast", $$v)
                          },
                          expression: "ruleForm.blackToast",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form_bj_box no_bjc" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "优先级", prop: "priority" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.ruleForm.priority,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "priority", $$v)
                          },
                          expression: "ruleForm.priority",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "生效状态", prop: "state" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.state,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "state", $$v)
                            },
                            expression: "ruleForm.state",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("生效"),
                          ]),
                          _c("el-radio", { attrs: { label: "0" } }, [
                            _vm._v("失效"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注", prop: "remark" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", rows: "5" },
                        model: {
                          value: _vm.ruleForm.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "remark", $$v)
                          },
                          expression: "ruleForm.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "text-align": "center" } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.saveBtn } },
                    [_vm._v("保存")]
                  ),
                  _c("el-button", { on: { click: _vm.hide } }, [
                    _vm._v("取消"),
                  ]),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("channel-popups", {
        attrs: {
          "app-id": _vm.ruleForm.receiverChannelList,
          visible: _vm.showPopups,
        },
        on: {
          "update:visible": function ($event) {
            _vm.showPopups = $event
          },
          comfirm: _vm.handleConfirm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }